/* cg-enhance (Round 30, Oct 10 2026). Loaded sitewide from snippets/card-description-clamp.liquid.
   1. Native mode: points leftover Toast online-ordering links at our own menu / catering pages, and
      menu category links (/collections/breakfast etc.) at that category on the orderable menu page.
   2. Menu page: live search over every dish, the Uber / DoorDash habit.
   3. Catering: holiday hours from the catering cg_ordering_rules metaobject (window.CGC_HOLIDAYS)
      trim the time picker (Thanksgiving 5 AM to 5 PM, Christmas closed, etc).
   4. Side cart: every add to cart (menu sheet, catering page, dish pages) slides open the cart drawer.
      The drawer's button goes to /cart, where guests pick pickup or delivery and a time before checkout.
   5. Quick add buttons on product cards open the item sheet so required choices are always picked.
   6. Mobile polish: no overlapping floating buttons, tighter menu cards, category landing, one Add on dish pages. */
(function () {
  'use strict';
  var CFG = window.CG_ENHANCE || {};

  /* 1. Toast links */
  var MENU_HANDLES = CFG.menuHandles || [];
  function menuAnchorFor(path) {
    var m = /^\/collections\/([a-z0-9-]+)\/?$/.exec(path || '');
    if (!m) return null;
    if (m[1] === 'all') return CFG.menuUrl || '/pages/food-menu-new';
    return MENU_HANDLES.indexOf(m[1]) > -1 ? (CFG.menuUrl || '/pages/food-menu-new') + '#cgm-' + m[1] : null;
  }
  function fixLinks() {
    if (!CFG.native) return;
    document.querySelectorAll('a[href]').forEach(function (a) {
      var h = a.hostname || '', p = (a.pathname || '').toLowerCase();
      if (h === location.hostname) {
        var to = menuAnchorFor(p); if (to) { a.setAttribute('href', to); return; }
        /* "Start a catering order" buttons go straight to the orderable catering menu, not the info page */
        if (p === '/pages/catering' && /start (a |your )?catering order|order catering/i.test(a.textContent || '')) { a.setAttribute('href', '/collections/catering'); return; }
      }
      /* Toast reservations and rewards sign-up: our own pages, so every request lands in our inbox / customer list */
      if (/^booking\.toasttab\.com$/.test(h)) { a.setAttribute('href', '/pages/reservations'); a.removeAttribute('target'); return; }
      if (/(^|\.)toasttab\.com$/.test(h) && /rewards/i.test(p)) { a.setAttribute('href', '/pages/rewards'); a.removeAttribute('target'); return; }
      /* Toast catering lead form: use our on-site quote form on the catering page instead */
      if (/(^|\.)toasttab\.com$/.test(h) && /\/invoice\/lead/.test(p)) { a.setAttribute('href', '/collections/catering#cgc-quote'); a.removeAttribute('target'); return; }
      var isToast = /(^|\.)toasttab\.com$/.test(h) && h.indexOf('booking') !== 0 && /california-grill/.test(p) && !/giftcard|reward/.test(p);
      if (h === 'order.californiagrill.com' || isToast) {
        a.setAttribute('href', /catering/.test(p) ? '/collections/catering' : (CFG.menuUrl || '/pages/food-menu-new'));
        a.removeAttribute('target');
      }
    });
  }

  /* 2. Menu search */
  function menuSearch() {
    var root = document.querySelector('[data-cgm]'); if (!root || root.querySelector('.cgm-search')) return;
    var nav = root.querySelector('.cgc-nav'); if (!nav) return;
    var css = document.createElement('style');
    css.textContent = '.cgm-search{position:relative;max-width:1200px;margin:18px auto 6px;padding:0 16px}' +
      '.cgm-search input{width:100%;height:48px;border:1px solid #e3e1dc;border-radius:999px;padding:0 70px 0 44px;font-size:16px;background:#fff;color:#121212;box-shadow:0 1px 2px rgba(0,0,0,.04);-webkit-appearance:none}' +
      '.cgm-search input:focus{outline:none;border-color:#d94300;box-shadow:0 0 0 3px rgba(217,67,0,.15)}' +
      '.cgm-search svg{position:absolute;left:32px;top:15px;color:#6b6b6b;pointer-events:none}' +
      '.cgm-search button{position:absolute;right:28px;top:12px;border:0;background:none;color:#d94300;font-weight:700;font-size:14px;cursor:pointer;padding:4px}' +
      '.cgm-search__none{max-width:1200px;margin:24px auto;padding:0 16px;font-size:16px;color:#48494b}' +
      '.cgm.is-searching .cgc-nav,.cgm.is-searching .cgc-section__count,.cgm.is-searching .cgm-section__note{display:none}';
    document.head.appendChild(css);
    var box = document.createElement('div'); box.className = 'cgm-search'; box.setAttribute('role', 'search');
    box.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M10 4a6 6 0 104.47 10l4.77 4.76 1.06-1.06-4.76-4.77A6 6 0 0010 4zm0 1.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"/></svg>' +
      '<input type="search" placeholder="Search the menu: burger, pancakes, salad" aria-label="Search the menu" autocomplete="off" enterkeyhint="search">' +
      '<button type="button" hidden aria-label="Clear search">Clear</button>';
    nav.parentNode.insertBefore(box, nav);
    var none = document.createElement('p'); none.className = 'cgm-search__none'; none.hidden = true;
    none.innerHTML = 'Nothing matches that. Try another word, or <a href="tel:5629077017">call (562) 907-7017</a> and we will make it happen.';
    nav.parentNode.insertBefore(none, nav.nextSibling);
    var q = box.querySelector('input'), clr = box.querySelector('button');
    var cards = [].slice.call(root.querySelectorAll('.cgc-card')).map(function (c) {
      var t = c.querySelector('.cgc-card__title'), d = c.querySelector('.cgc-card__desc');
      return { el: c, txt: ((t ? t.textContent : '') + ' ' + (d ? d.textContent : '')).toLowerCase() };
    });
    var secs = [].slice.call(root.querySelectorAll('[data-cgm-section]')), timer;
    function run() {
      var v = q.value.trim().toLowerCase(), words = v.split(/\s+/).filter(Boolean), shown = 0;
      root.classList.toggle('is-searching', !!v); clr.hidden = !v;
      cards.forEach(function (c) { var ok = !words.length || words.every(function (w) { return c.txt.indexOf(w) > -1; }); c.el.style.display = ok ? '' : 'none'; if (ok) shown++; });
      secs.forEach(function (s) { var any = [].some.call(s.querySelectorAll('.cgc-card'), function (c) { return c.style.display !== 'none'; }); s.style.display = any ? '' : 'none'; });
      none.hidden = !(v && !shown);
    }
    q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); q.blur(); } });
    clr.addEventListener('click', function () { q.value = ''; run(); q.focus(); });
  }

  /* 3. Catering holiday hours */
  var HOL = window.CGC_HOLIDAYS || [];
  function hm(v) { var m = /^(\d{1,2}):(\d{2})/.exec(v || ''); return m ? (+m[1]) * 60 + (+m[2]) : null; }
  function parseT(s) { var m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec((s || '').trim()); if (!m) return null; var h = +m[1] % 12; if (m[3].toUpperCase() === 'PM') h += 12; return h * 60 + (+m[2]); }
  function holidayFor(d) { for (var i = 0; i < HOL.length; i++) if (HOL[i] && HOL[i].date === d) return HOL[i]; return null; }
  function trimTimes(sel, dateIn) {
    var h = holidayFor(dateIn.value); if (!h) return;
    var o = hm(h.open), c = hm(h.close), before = sel.value, changed = false;
    if (o == null || c == null) {
      if (sel.options.length === 1 && sel.options[0].value === '' && sel.disabled) return;
      sel.innerHTML = ''; sel.appendChild(new Option((h.note || 'Closed that day') + '. Pick another date.', '')); sel.disabled = true; changed = true;
    } else {
      [].slice.call(sel.options).forEach(function (op) { var t = parseT(op.value); if (t != null && (t < o || t > c)) { op.remove(); changed = true; } });
      if (changed && sel.options.length === 1) sel.options[0].text = (h.note || 'Holiday hours') + '. No times left, pick another date.';
    }
    if (changed && sel.value !== before) sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function cateringHolidays() {
    if (!HOL.length) return;
    document.querySelectorAll('[data-cgc-time]').forEach(function (sel) {
      var scope = sel.closest('[data-cgc-setup]') || sel.closest('form') || document;
      var dateIn = scope.querySelector('[data-cgc-date]'); if (!dateIn) return;
      var busy = false;
      function go() { if (busy) return; busy = true; try { trimTimes(sel, dateIn); } finally { busy = false; } }
      new MutationObserver(go).observe(sel, { childList: true });
      go();
    });
  }

  /* 4. Side cart */
  var drawerCss = '' +
    'cart-drawer .drawer__inner{border-radius:18px 0 0 18px;box-shadow:-12px 0 40px rgba(0,0,0,.18)}' +
    'cart-drawer .drawer__heading{font-size:2.2rem;font-weight:800}' +
    'cart-drawer thead{display:none!important}' +
    'cart-drawer .cart-item__image{border-radius:12px;width:72px;height:72px;object-fit:cover}' +
    'cart-drawer .cart-item__name{font-weight:700;text-decoration:none}' +
    'cart-drawer .quantity{border-radius:999px;min-height:40px}' +
    'cart-drawer .quantity:after,cart-drawer .quantity:before{border-radius:999px}' +
    'cart-drawer .tax-note{display:none}' +
    '#CartDrawer-Checkout{background:#d94300;border-radius:999px;min-height:54px;font-size:1.7rem;font-weight:800;letter-spacing:0}' +
    '#CartDrawer-Checkout:after,#CartDrawer-Checkout:before{border-radius:999px;box-shadow:none}' +
    '.cg-drawer-next{margin:10px 0 0;text-align:center;font-size:1.35rem;color:#48494b}' +
    '.cg-drawer-more{display:block;margin:10px auto 0;text-align:center;font-weight:700;color:#d94300;background:none;border:0;font-size:1.45rem;cursor:pointer}' +
    'cart-drawer .drawer__footer{padding-top:14px}' +
    'cart-drawer .cart__ctas{display:flex!important;flex-direction:column!important;align-items:stretch!important;gap:0!important}' +
    'cart-drawer .cart__ctas>*{width:100%!important;margin:0!important}' +
    'cart-drawer .cart-drawer__footer>div:first-child,cart-drawer .totals{margin-bottom:10px}' +
    '@media screen and (max-width:749px){cart-drawer .drawer__inner{border-radius:0;width:100vw;max-width:100vw}cart-drawer .drawer__inner-empty,cart-drawer .drawer__footer{padding-bottom:max(14px,env(safe-area-inset-bottom))}}';
  function drawer() { return document.querySelector('cart-drawer'); }
  function decorateDrawer() {
    var d = drawer(); if (!d) return;
    var btn = d.querySelector('#CartDrawer-Checkout'); if (!btn || btn.dataset.cg) return;
    btn.dataset.cg = '1';
    var total = d.querySelector('.totals__subtotal-value');
    btn.textContent = 'Check out' + (total ? ' · ' + total.textContent.trim().replace(/\s*USD$/, '') : '');
    var note = document.createElement('p'); note.className = 'cg-drawer-next';
    note.textContent = 'Next: pickup or delivery, ASAP or a time that works.';
    var more = document.createElement('button'); more.type = 'button'; more.className = 'cg-drawer-more'; more.textContent = 'Keep ordering';
    more.addEventListener('click', function () { d.close(); });
    btn.parentNode.appendChild(note); btn.parentNode.appendChild(more);
  }
  /* a drawer that loaded empty keeps its empty class after the first add, which hides the items (blank white panel) */
  function unEmpty() {
    var d = drawer(); if (!d || !d.querySelector('.cart-item')) return;
    d.classList.remove('is-empty');
    var inner = d.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
  }
  function openDrawer() {
    var d = drawer(); if (!d || typeof d.renderContents !== 'function') return;
    fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sections) {
      d.renderContents({ sections: sections });
      setTimeout(function () { unEmpty(); decorateDrawer(); }, 30);
    }).catch(function () {});
  }
  function sideCart() {
    var d = drawer(); if (!d) return;
    var css = document.createElement('style'); css.textContent = drawerCss; document.head.appendChild(css);
    decorateDrawer();
    new MutationObserver(function () { unEmpty(); decorateDrawer(); }).observe(d, { childList: true, subtree: true });
    /* the drawer button goes to the cart page, where the pickup / delivery and time step lives */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('#CartDrawer-Checkout');
      if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href = '/cart';
    }, true);
    /* menu page: the cart icon opens the side cart too */
    if (document.querySelector('[data-cgm]')) {
      document.addEventListener('click', function (e) {
        var ci = e.target.closest && e.target.closest('#cart-icon-bubble');
        if (!ci) return;
        e.preventDefault(); e.stopPropagation();
        openDrawer();
      }, true);
    }
    /* our own add-to-cart calls (menu sheet, catering page) open the side cart once the item is in */
    if (window.fetch && !window.fetch.__cg) {
      var orig = window.fetch;
      var wrapped = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = orig.apply(this, arguments);
        if (/\/cart\/add\.js(\?|$)/.test(url) && location.pathname.indexOf('/cart') !== 0) {
          p.then(function (r) { if (r && r.ok) setTimeout(openDrawer, 250); }).catch(function () {});
        }
        return p;
      };
      wrapped.__cg = true; window.fetch = wrapped;
    }
  }

  /* 5. Quick add on product cards (homepage "Most loved" etc.): open the same item sheet as the menu
        so required choices (sides, temps, dressings) are picked and land in Toast as real modifiers. */
  var sheetCache = {};
  function quickSheet() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.cg-loved__cta.cg-when-native, .quick-add__submit');
      if (!btn || !CFG.native) return;
      var card = btn.closest('.grid__item, .card-wrapper, li') || btn.parentNode;
      var link = card && card.querySelector('a[href*="/products/"]');
      if (!link) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var url = link.getAttribute('href').split('?')[0];
      function open(p) {
        if (p && window.CGMenu && typeof window.CGMenu.openSheet === 'function') window.CGMenu.openSheet(p);
        else window.location.href = url;
      }
      if (sheetCache[url]) return open(sheetCache[url]);
      btn.setAttribute('aria-busy', 'true');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tag = doc.querySelector('script[data-cgm-product]'), p = null;
        try { p = tag ? JSON.parse(tag.textContent) : null; } catch (err) {}
        sheetCache[url] = p; open(p);
      }).catch(function () { window.location.href = url; }).then(function () { btn.removeAttribute('aria-busy'); });
    }, true);
  }

  /* 6. Polish pass (Round 30 mobile CX audit) */
  var polishCss = '' +
    /* the spin teaser and the old order pill never sit on top of the order bar */
    'body:has(.cgc-bar.is-visible) .cgsw{transform:translateY(-112px)}' +
    'body:has(.cgc-modal.is-open) .cgsw,body:has(cart-drawer.active) .cgsw{display:none!important}' +
    /* homepage hero fills the screen on phones (no white bands above and below the photo) */
    '@media (max-width:749px){[id*="new_slideshow"] .slideshow__slide{min-height:480px!important}}' +
    'body:has(.cgm-bar) .cgoc-pill{display:none!important}' +
    /* menu cards: tighter on phones so more dishes fit per scroll, like the delivery apps */
    '@media (max-width:749px){.cgm .cgc-card{padding:10px;gap:10px}.cgm .cgc-card__desc{-webkit-line-clamp:2}.cgm .cgc-card__media img{width:96px;height:96px}.cgm .cgc-card__title{font-size:1.6rem}}' +
    /* homepage order block: category pills scroll sideways on phones instead of stacking five rows */
    '@media (max-width:749px){.cg-order-flow__tabs{flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;margin-right:-18px;padding-right:18px}.cg-order-flow__tabs::-webkit-scrollbar{display:none}.cg-tab-btn{flex:0 0 auto}.cg-tab-panel{max-height:none}}' +
    /* dish page: one Add button (the one with the options sheet), placed right under the price */
    'html.cg-native body.cg-pdp-sheet #cg-ot .cg-when-native{display:none!important}' +
    'body.cg-pdp-sheet .cgm-pdp .cgc-add{background:#E83212;border-radius:12px;font-size:1.8rem;font-weight:800;box-shadow:0 6px 16px rgba(232,50,18,.28)}';
  function polish() {
    var css = document.createElement('style'); css.textContent = polishCss; document.head.appendChild(css);
    if (!CFG.native) return;
    /* tile buttons that now open the orderable menu read as an order, not a brochure */
    document.querySelectorAll('a[href*="/pages/food-menu-new#cgm-"], a[href="/collections/catering"]').forEach(function (a) {
      if (/^\s*view menu\s*$/i.test(a.textContent)) a.textContent = /catering/.test(a.getAttribute('href')) ? 'Order catering' : 'Order now';
    });
    /* menu page opened at a category (#cgm-breakfast): land on it, under the sticky header and tabs */
    if (/^#cgm-/.test(location.hash)) {
      var go = function () {
        var el = document.getElementById(location.hash.slice(1)); if (!el) return;
        var hdr = document.querySelector('.section-header, sticky-header, header'), nav = document.querySelector('.cgc-nav');
        var off = (hdr ? Math.min(hdr.getBoundingClientRect().height, 120) : 0) + (nav ? nav.getBoundingClientRect().height : 0) + 8;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'instant' });
      };
      setTimeout(go, 150); setTimeout(go, 900);
    }
    /* breadcrumb on dish pages: no internal collection names, Menu goes to the orderable menu */
    var crumb = document.querySelector('.cg-crumb');
    var fixCrumb = function () {
      var c = document.querySelector('.cg-crumb'); if (!c || c.dataset.cg) return; c.dataset.cg = '1';
      c.querySelectorAll('a').forEach(function (a) {
        if (/tax override|all products/i.test(a.textContent)) { var sep = a.previousElementSibling; if (sep && sep.tagName === 'SPAN') sep.remove(); a.remove(); }
        else if (/^\/pages\/menu\/?$/.test(a.getAttribute('href') || '')) a.setAttribute('href', CFG.menuUrl || '/pages/food-menu-new');
      });
    };
    /* dish page: route every Add (top tile, sticky bar) through the options sheet */
    var pdpAdd = document.querySelector('.cgm-pdp [data-cgm-add]');
    if (pdpAdd) {
      document.body.classList.add('cg-pdp-sheet');
      var place = function () {
        fixCrumb();
        var ot = document.getElementById('cg-ot'), pdp = document.querySelector('.cgm-pdp');
        if (ot && pdp && pdp.parentElement !== ot) { var note = ot.querySelector('.cg-ot__note'); ot.insertBefore(pdp, note || null); }
      };
      place(); var tries = 0, iv = setInterval(function () { place(); if (++tries > 20) clearInterval(iv); }, 300);
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('#cg-bar [data-add], #cg-ot [data-add]');
        if (!b) return;
        e.preventDefault(); e.stopImmediatePropagation(); pdpAdd.click();
      }, true);
    } else if (crumb || /\/products\//.test(location.pathname)) {
      var t2 = 0, iv2 = setInterval(function () { fixCrumb(); if (++t2 > 20) clearInterval(iv2); }, 300);
    }
    /* catering quote: arriving at #cgc-quote (or tapping a link to it) opens the quote form */
    var openQuote = function () { var q = document.querySelector('#cgc-quote details'); if (q) { q.open = true; document.getElementById('cgc-quote').scrollIntoView({ behavior: 'smooth', block: 'start' }); } };
    if (location.hash === '#cgc-quote') setTimeout(openQuote, 400);
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href$="#cgc-quote"]'); if (a && document.getElementById('cgc-quote')) { e.preventDefault(); openQuote(); } });
    /* the old order pill (pages without the menu bar) opens the side cart */
    document.addEventListener('click', function (e) {
      var p = e.target.closest && e.target.closest('.cgoc-pill');
      if (!p || !drawer()) return;
      e.preventDefault(); e.stopImmediatePropagation(); openDrawer();
    }, true);
  }

  /* 7. Oct 10 pass: Events in the menu, rewards on the new program, bigger catering capacity, B2B accounts,
        catering page and cart get to the order faster on phones */
  var r30Css = '' +
    /* open hamburger menu always sits above page panels (catering setup used to bleed through) */
    'body:has(header-drawer details[open]) .section-header,body:has(header-drawer details[open]) sticky-header{z-index:1000!important;position:relative}' +
    'body:has(header-drawer details[open]) .cgc-setup,body:has(header-drawer details[open]) .lux-bar,body:has(header-drawer details[open]) .cgc-bar,body:has(header-drawer details[open]) .cgm-bar,body:has(header-drawer details[open]) .cgsw{visibility:hidden}' +
    '.cg-nav-events a{font-weight:800!important;color:#d94300!important}' +
    /* catering page on phones: headline, one short line, then straight into date / time / headcount */
    '@media (max-width:749px){' +
      '.cgc-hero{padding-top:10px!important;padding-bottom:4px!important}' +
      '.cgc-hero__kicker{font-size:1.05rem!important;letter-spacing:.06em!important;margin-bottom:2px!important}' +
      '.cgc-hero h1{font-size:2.8rem!important;line-height:1.08!important;margin:2px 0 6px!important}' +
      '.cgc-hero__sub{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:1.4rem!important;line-height:1.45!important;margin:0 0 6px!important}' +
      '.cgc-hero .cgc-trust{display:none!important}' +
      '.cgc-proof{font-size:1.25rem!important;margin:0 0 10px!important}.cgc-proof>span:nth-child(n+3){display:none!important}' +
      '.cgc-setup{display:grid!important;grid-template-columns:1fr 1fr;gap:10px!important;padding:14px!important}' +
      '.cgc-setup>.cgc-setup__mode,.cgc-setup>.cgc-setup__note,.cgc-setup>.cgc-field--zip{grid-column:1/-1}' +
      '.cgc-setup .cgc-field{margin:0!important;min-width:0}.cgc-setup .cgc-field input,.cgc-setup .cgc-field select{min-width:0;width:100%}' +
      '.cgc-setup__note{font-size:1.25rem!important;line-height:1.45!important}' +
    '}' +
    /* cart: company / tax-exempt options fold into one line under the checkout button */
    '.lux-biz-wrap{margin:12px 0 0;border:1px solid #e6e1d7;border-radius:12px;background:#fff}' +
    '.lux-biz-wrap>summary{list-style:none;cursor:pointer;padding:12px 14px;font-weight:700;font-size:1.4rem;color:#1a1a1a;display:flex;justify-content:space-between;align-items:center}' +
    '.lux-biz-wrap>summary::-webkit-details-marker{display:none}.lux-biz-wrap>summary:after{content:"+";font-size:2rem;color:#d94300;line-height:1}' +
    '.lux-biz-wrap[open]>summary:after{content:"−"}.lux-biz-wrap .lux-biz{margin:0!important;padding:0 14px 14px!important;border:0!important}' +
    '.lux-biz-acct{display:block;margin-top:8px;font-weight:700;color:#b83a00!important}';
  function eventsLink() {
    var url = '/pages/events';
    var mm = document.querySelector('.menu-drawer__menu');
    if (mm && !mm.querySelector('.cg-nav-events')) {
      var tpl = mm.querySelector(':scope > li'); if (tpl) {
        var li = document.createElement('li'); li.className = 'cg-nav-events';
        var a0 = tpl.querySelector('a, summary'), cls = a0 ? a0.className : 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
        li.innerHTML = '<a href="' + url + '" class="' + cls.replace(/menu-drawer__menu-item--active/g, '') + '">Events</a>';
        mm.insertBefore(li, mm.firstElementChild);
      }
    }
    var dm = document.querySelector('.header__inline-menu > ul');
    if (dm && !dm.querySelector('.cg-nav-events')) {
      var items = [].slice.call(dm.children), after = null;
      items.forEach(function (li) { if (/^\s*catering\s*$/i.test(li.textContent)) after = li; });
      var t = items[0]; if (t) {
        var c = t.cloneNode(true); c.classList.add('cg-nav-events');
        var a = c.querySelector('a'); if (a) { a.setAttribute('href', url); a.removeAttribute('aria-current'); var sp = a.querySelector('span') || a; sp.textContent = 'Events'; a.classList.remove('header__menu-item--active'); }
        if (a) dm.insertBefore(c, after ? after.nextSibling : null);
      }
    }
  }
  function swapText(root) {
    var map = [
      [/75 to 300\+ guests/g, '75 to 1,000+ guests'],
      [/10 to 300\+ Guests/g, '10 to 1,000+ Guests'],
      [/Feeding 10 people or 300,/g, 'Feeding 10 people or 1,000,'],
      [/Secure checkout on californiagrill\.com\. Points on every order\./g, 'Secure checkout on californiagrill.com. No app fees.'],
      [/Direct orders can earn you California Grill Rewards\./g, 'Direct orders count toward the new CG Rewards, one account in the restaurant and online.']
    ];
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue, o = v; if (!v || v.length < 8) continue;
      map.forEach(function (m) { v = v.replace(m[0], m[1]); });
      if (v !== o) n.nodeValue = v;
    }
  }
  function rewardsCopy() {
    var sec = document.querySelector('.sec-rewards-01'); if (!sec) return;
    var cap = sec.querySelector('.image-with-text__text--caption'); if (cap) cap.textContent = 'CG Rewards · New program';
    var hd = sec.querySelector('.image-with-text__heading'); if (hd) hd.textContent = 'Rewards that work everywhere you order';
    var tx = sec.querySelector('.image-with-text__text.rte, .image-with-text__text:not(.image-with-text__text--caption)');
    if (tx) tx.innerHTML = '<p>Our new CG Rewards program earns in the restaurant, on californiagrill.com and at CG Meals, all in one account. Join now and you are set the day it launches.</p>';
    var b = sec.querySelector('a.button'); if (b) { b.textContent = 'Join CG Rewards'; b.setAttribute('href', '/pages/rewards'); b.removeAttribute('target'); }
  }
  function bizFold() {
    var biz = document.querySelector('.lux-summary .lux-biz'); if (!biz || biz.closest('.lux-biz-wrap')) return;
    var sm = biz.querySelector('small');
    if (sm) sm.innerHTML = 'Tax ID, card or ACH on file, POs and Net-30 billing: <a class="lux-biz-acct" href="/pages/catering-accounts">Open a catering account →</a>';
    var det = document.createElement('details'); det.className = 'lux-biz-wrap';
    det.innerHTML = '<summary>Company or tax-exempt order?</summary>';
    var ctas = document.querySelector('#main-cart-footer .cart__ctas');
    if (biz.querySelector('input:checked')) det.open = true;
    if (ctas && ctas.parentNode) ctas.parentNode.insertBefore(det, ctas.nextSibling); else biz.parentNode.insertBefore(det, biz);
    det.appendChild(biz);
  }
  function r30() {
    var css = document.createElement('style'); css.textContent = r30Css; document.head.appendChild(css);
    eventsLink(); swapText(); rewardsCopy();
    setTimeout(function () { eventsLink(); swapText(); }, 1500);
    if (/^\/cart/.test(location.pathname)) {
      bizFold();
      var tries = 0, iv = setInterval(function () { bizFold(); if (document.querySelector('.lux-biz-wrap') || ++tries > 30) clearInterval(iv); }, 250);
    }
  }

  function boot() { fixLinks(); setTimeout(fixLinks, 1500); menuSearch(); cateringHolidays(); sideCart(); quickSheet(); polish(); r30(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
